export const environment = {
  production: true,
  appVersion: 'v8.0.37',
  apiUrl: 'https://gatemateapi.valexconsulting.com/api',
  mapboxToken: 'pk.eyJ1Ijoid2hocm9vNiIsImEiOiJjbWJhaTVkejQxOTVyMm1wOWFnOXI2eG5oIn0.flF9K7U5d64s_pXyYTTY-w',
  mapboxStyle: 'cmbajh1oj00ve01s68kaka4mg',
  mapboxUser: 'whhroo6',
};
